import { ReactComponent as ArrowDownIcon } from '../../assets/icons/arrowDown.svg';
import useMainStore from '../../store/mainState';
import AcardionMenuItem from './AcardionMenuItem';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



const AcardionItem = ({ item, activeItem, setActiveItem, isCollapsed, activeSubItem, setActiveSubItem }: any) => {
    const navigate = useNavigate();
    const { setIsCollapsed } = useMainStore();
    const { t } = useTranslation();

    return (
        <div key={item.id} className="accordion-item">
            <button
                className={`accordion-header ${activeItem === item.id ? 'active' : ''}`}
                onClick={() => {
                    console.log({ activeItem: item.id });

                    if (item.context) {

                        setActiveItem(item.id)

                    } else {
                        if (item.id.includes('sport')) {
                            setIsCollapsed(true)
                        }
                        if (item.id.includes('LIVE')) {
                            setIsCollapsed(true)
                            setActiveItem('casino')
                            setActiveSubItem('LIVE')
                            navigate('/casino')
                            return
                        }
                        setActiveItem(activeItem === item.id ? null : item.id)
                        navigate(item.id)
                    }
                }}
            >
                <div className="sidebar-item-icon">{item.icon}</div>
                {!isCollapsed && (
                    <>
                        <span className="sidebar-item-label">{t(item.labelKey)}</span>
                        {item.context && (
                            <div className={`accordion-arrow ${activeItem === item.id ? 'expanded' : ''}`}>
                                <ArrowDownIcon />
                            </div>
                        )}
                    </>
                )}
            </button>
            {!isCollapsed && item.context && (
                <AcardionMenuItem item={item} activeItem={activeItem} setActiveItem={setActiveItem} activeSubItem={activeSubItem} setActiveSubItem={setActiveSubItem} navigate={navigate} />
            )}
        </div>
    )
}

export default AcardionItem
